import Duck from 'extensible-duck';
import createEntityDuck from '../../util/genericEntityDuck';

const namespace = 'settings';
const storeKey = 'organizationSettings';

const duck = createEntityDuck(namespace, storeKey, 'id', namespace).extend({
  initialState: {
    data: {},
  },
  selectors: {
    configuration: new Duck.Selector(selectorsInput => state => selectorsInput.data(state)),
    role: new Duck.Selector(selectorsInput => state => selectorsInput.data(state).role),
    isAdmin: new Duck.Selector(
      selectorsInput => state => selectorsInput.role(state) === 'ADMIN' || selectorsInput.role(state) === 'OWNER'
    ),
    isOwner: new Duck.Selector(selectorsInput => state => selectorsInput.role(state) === 'OWNER'),
  },
});

export { duck as default, storeKey };
export const { creators, reducer, types, selectors, initialState } = duck;
